

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <DatosUsuario></DatosUsuario>
</v-col>
</v-row>  


<v-row justify="end" >
        
        <v-col cols="2" >





        </v-col>
      </v-row>



</v-container>
   
</div>
</template>

<script>

import DatosUsuario from '@/components/auto_register/gestion/DatosUsuario.vue';


export default {
    data () {
    return {
              
    }
  },
  components: {
    
    DatosUsuario
    
  },

  methods: {

}

}
    

</script>


